import React, { ReactNode } from "react";
import PosterWithFloatingTrailerButton from "src/components/filmlistwithproviders/PosterWithFloatingTrailerButton";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import StreamingProviderList from "src/components/streaming/StreamingProviderList";
import { type StreamingProviderContent } from "src/lib/movieinfo/movieinfotypes";
import { type IFilmomtale } from "src/lib/types/Filmomtale";
import styles from "./FilmWithProvider.module.css";

//#region [Props]
type FilmWithProviderProps = {
    film: IFilmomtale;
    isLoadingProviders: boolean;
    providers?: StreamingProviderContent[];
    streamingId?: number;
    children?: ReactNode;
    hideKinoklubb?: boolean;

};
//#endregion

//#region [Component]
export default function FilmWithProvider({ film, isLoadingProviders, providers, streamingId, children, hideKinoklubb = false }: FilmWithProviderProps) {

    return <article className={styles.FilmWithProvider}>
        <PosterWithFloatingTrailerButton film={film} className={styles.Poster} hideKinoklubb={hideKinoklubb} />
        <div className={styles.MainInfo}>
            <h1 className={styles.Title}><FilmwebLink to={`/film/${film.mainVersionEDI}`}>{film.title}</FilmwebLink></h1>
            {film.directorV2 && <p>Regi: {film.directorV2}</p>}
            {film.castV2 && <p>Skuespillere: {film.castV2}</p>}
            {React.Children.map(children, child => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { film: film } as { film: IFilmomtale; });
                }
                return child;
            })}
        </div>
        <div className={styles.Providers}>
            {isLoadingProviders && <LoadingIndicator size="large" position="InlineCenter" />}
            {!isLoadingProviders && streamingId && <StreamingProviderList
                label="Her kan du se eller kjøpe filmen:"
                streamingId={streamingId}
                providers={providers}
                providerClassName={styles.Provider}
                providerListContainerClassName={styles.ProviderListContainer}
            />}
        </div>
    </article>;
}
//#endregion
